import * as Sentry from '@sentry/vue';

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

export default function sentry(app, router) {
  if (!SENTRY_DSN) {
    return;
  }

  Sentry.init({
    app,
    dsn: SENTRY_DSN,
    environment: import.meta.env.MODE,
    // Without `release` the stacktrace comes back untranslated: source maps match by release.
    release: import.meta.env.VITE_RELEASE,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
    ],
  });
}
